import {
  ProtectedDocument,
  useGetDocumentPasswordsQuery,
} from '@/store/api/referenceApi';

/**
 * The password of a protected external document, served by the backend so it is not
 * shipped in the bundle. Undefined while loading, on error, or when none is configured —
 * callers then show the document link without a password.
 */
export const useDocumentPassword = (
  document: ProtectedDocument
): string | undefined => {
  const { data } = useGetDocumentPasswordsQuery();
  return data?.find(entry => entry.document === document)?.password;
};
